import React, { Component } from 'react'
import '../styles/Blacklist.css'

class HistNumber extends Component {
    render() {
        return (
            <tr>
                <td>
                    <p>{this.props.number.icon}{this.props.number.status}</p>
                </td>
                <td>
                    {this.props.number.number}
                </td>
                <td>
                    {this.props.number.calltime}
                </td>
            </tr>
        )
    }
}

class CallHistory extends Component {
    render() {
        return (
            <table>
                <tbody>
                    <tr><th>statut</th><th>numéro</th><th>heure de l'appel</th></tr>
                    {this.props.history.map((number, id) => <HistNumber key={id} number={number}/>)}
                </tbody>
            </table>
        )
    }
}

export default CallHistory